export default __webpack_public_path__ + "static/media/UT_Dallas_Black.8287056c.png";